// ─── 날짜·시간·숫자 포매터 ────────────────────────────────────────────────────

/** ISO 날짜 문자열을 한국어 날짜·시간으로 포매팅 */
export function fmtTime(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ko-KR', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true,
  });
}

/** 밀리초를 s / ms 단위로 포매팅 */
export function fmtMs(ms) {
  if (ms == null) return '—';
  return ms >= 1000 ? `${(ms / 1000).toFixed(1)}s` : `${ms}ms`;
}

/** 오늘 날짜 문자열 반환 (YYYY-MM-DD) */
export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** 오늘 기준 n일 오프셋 날짜 문자열 반환 (YYYY-MM-DD) */
export function dateOffset(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** eval_score 값에 따른 색상 등급 반환 */
export function judge(score) {
  if (score == null) return { bar: 'bg-slate-200', text: 'text-slate-400' };
  if (score >= 90)   return { bar: 'bg-emerald-500', text: 'text-emerald-600' };
  if (score >= 70)   return { bar: 'bg-amber-500',   text: 'text-amber-600' };
  return { bar: 'bg-red-500', text: 'text-red-600' };
}
